function fallbackMode(responseModes, defaultResponseMode) {
  return responseModes.some(({ value }) => value === defaultResponseMode)
    ? defaultResponseMode
    : responseModes[0]?.value || null;
}

function storageKey(appId) {
  return `justiniano:${appId}:response-mode`;
}

function availableStorage(storage) {
  if (storage !== undefined) return storage;
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readResponseModePreference({
  appId,
  responseModes,
  defaultResponseMode,
  storage,
}) {
  const fallback = fallbackMode(responseModes, defaultResponseMode);
  const resolvedStorage = availableStorage(storage);
  if (!resolvedStorage || !appId) return fallback;
  try {
    const stored = resolvedStorage.getItem(storageKey(appId));
    return responseModes.some(({ value }) => value === stored)
      ? stored
      : fallback;
  } catch {
    return fallback;
  }
}

export function persistResponseModePreference(value, {
  appId,
  responseModes,
  defaultResponseMode,
  storage,
}) {
  const normalized = responseModes.some((mode) => mode.value === value)
    ? value
    : fallbackMode(responseModes, defaultResponseMode);
  const resolvedStorage = availableStorage(storage);
  if (resolvedStorage && appId && normalized) {
    try {
      resolvedStorage.setItem(storageKey(appId), normalized);
    } catch {
      // La preferencia sigue activa durante la sesión aunque no haya storage.
    }
  }
  return normalized;
}
